import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PageWidthService {
	public wrapperPad = new BehaviorSubject(0);

	refreshWidth = this.wrapperPad.asObservable();

	setPageWidths(page, wrapper) {
		const wrapperPadding = (page - wrapper) / 2 ? (page - wrapper) / 2 - 13.5 : 0;
		this.wrapperPad.next(wrapperPadding);
	}
}
